/*
 * Babblee · wishlist
 *
 * The heart previously toggled its own pressed state and nothing else — it
 * looked like a feature and stored nothing, so a saved item vanished on the
 * next page load and the product page heart did not record which variant the
 * shopper had actually chosen.
 *
 * This persists to localStorage keyed by variant, because "Beige" and "Blue"
 * are different things to save. Every heart on the page reflects the same
 * store, and the header count updates live.
 */
(function () {
  var KEY = 'bb:wishlist:v1';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      // Private mode, quota, corrupted value: degrade to an in-memory list
      // rather than throwing inside a click handler.
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, 200)));
    } catch (e) {
      /* nothing we can do; the UI has already updated */
    }
  }

  function keyOf(entry) {
    return String(entry.handle) + '::' + String(entry.variant || '');
  }

  function has(list, entry) {
    var k = keyOf(entry);
    for (var i = 0; i < list.length; i += 1) {
      if (keyOf(list[i]) === k) return true;
    }
    return false;
  }

  function remove(list, entry) {
    var k = keyOf(entry);
    return list.filter(function (x) { return keyOf(x) !== k; });
  }

  function entryFrom(button) {
    return {
      handle: button.getAttribute('data-handle') || '',
      variant: button.getAttribute('data-variant') || '',
      title: button.getAttribute('data-title') || '',
      at: Date.now(),
    };
  }

  /*
   * Display is product-level; storage stays variant-level.
   *
   * Saving "Vegeta / 0-3M" and returning to the page showed an empty heart,
   * because the page reloads on its default variant and the variant keys no
   * longer matched. A shopper does not think "I saved a variant" — they think
   * "I saved this" — so the heart lights for any saved variant of the product
   * while the record still remembers exactly which one.
   */
  function savedProduct(list, handle) {
    for (var i = 0; i < list.length; i += 1) {
      if (String(list[i].handle) === String(handle)) return true;
    }
    return false;
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-bb-wish]').forEach(function (button) {
      var on = savedProduct(list, button.getAttribute('data-handle'));
      button.setAttribute('aria-pressed', String(on));
      var label = button.getAttribute('data-title') || 'this item';
      button.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + label + (on ? ' from saved items' : ' to saved items'));
    });
    document.querySelectorAll('[data-bb-wish-count]').forEach(function (el) {
      el.textContent = String(list.length);
      el.hidden = list.length === 0;
    });
  }

  function toggle(button) {
    var entry = entryFrom(button);
    var list = read();
    var alreadySaved = savedProduct(list, entry.handle);
    var next = alreadySaved
      ? list.filter(function (x) { return String(x.handle) !== String(entry.handle); })
      : list.concat([entry]);
    write(next);
    paint();
    document.dispatchEvent(new CustomEvent('bb:wishlist:change', { detail: { count: next.length }, bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element ? event.target.closest('[data-bb-wish]') : null;
    if (!button) return;
    // The card is a stretched link; a heart click must not also open the product.
    event.preventDefault();
    event.stopPropagation();
    toggle(button);
  });

  // The product page rewrites data-variant as the shopper picks options, so the
  // heart always saves what is actually selected.
  document.addEventListener('bb:variant:change', function (event) {
    var id = event && event.detail && event.detail.id;
    if (!id) return;
    document.querySelectorAll('[data-bb-wish][data-bb-wish-live]').forEach(function (button) {
      button.setAttribute('data-variant', String(id));
    });
    paint();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
  // Sections re-render on cart and search updates; repaint so hearts stay true.
  document.addEventListener('shopify:section:load', paint);
  window.addEventListener('pageshow', paint);
})();
